module.exports = __webpack_public_path__ + "media/images/icons/arrow-right-blue-bc9f99b298d6a47e5ae0fa9325171f1d.svg";